export default "__VITE_ASSET__D1$_CKHE__"